class Info {
	constructor() {
		this.cars = [
			{
				name: 'ラクーン2',
				store: '名古屋店',
				wd: 8000,
				wd_op: 4000,
				hd: 10000,
				hd_op: 5000,
				rentals: [
					{
						id: 1,
						name: 'テーブル',
						price: 500,
						img: 'table.png',
					},
					{
						id: 11,
						name: 'ローチェア2脚セット',
						price: 600,
						img: 'low_chair.jpg',
					},
					{
						id: 12,
						name: 'ローチェア3脚セット',
						price: 800,
						img: 'low_chair.jpg',
					},
					{
						id: 3,
						name: 'カーサイドタープ',
						price: 800,
						img: 'tarp.png',
					},
					{
						id: 13,
						name: 'ポップアップサンシェード(3~4人用)',
						price: 700,
						img: 'popup_shade.jpg',
					},
					{
						id: 4,
						name: '焚火台',
						price: 1500,
						img: 'firegrill.png',
					},
					{
						id: 5,
						name: 'LEDランタン',
						price: 500,
						img: 'led_lantern.png',
					},
					{
						id: 7,
						name: 'モバイルWi-Fi',
						price: 1000,
						img: 'wifi.jpg',
					},
					{
						id: 8,
						name: 'シュラフ 1個',
						price: 500,
						img: 'sleeping_bag.png',
					},
					{
						id: 9,
						name: 'シュラフ 2個セット',
						price: 800,
						img: 'sleeping_bag.png',
					},
					{
						id: 10,
						name: 'シュラフ 3個セット',
						price: 1100,
						img: 'sleeping_bag.png',
					},
					{
						id: 14,
						name: 'ソーラーパネル',
						price: 800,
						img: 'solor_panel.png',
					},
				]
			},
			{
				name: 'JP STAR H1',
				store: '大阪店',
				wd: 8000,
				wd_op: 4000,
				hd: 10000,
				hd_op: 5000,
				rentals: [
					{
						id: 1,
						name: 'テーブル',
						price: 500,
						img: 'table.png',
					},
					{
						id: 11,
						name: 'ローチェア2脚セット',
						price: 600,
						img: 'low_chair.jpg',
					},
					{
						id: 7,
						name: 'モバイルWi-Fi',
						price: 1000,
						img: 'wifi.jpg',
					},
				]
			},
			{
				name: 'JP STAR H1',
				store: '川崎店',
				wd: 8000,
				wd_op: 4000,
				hd: 10000,
				hd_op: 5000,
				rentals: [
				]
			},
			{
				name: 'JP STAR H1+',
				store: '北陸店',
				wd: 8000,
				wd_op: 4000,
				hd: 10000,
				hd_op: 5000,
				rentals: [
				]
			},
		];

		this.timeZone = {
			start: '09:00',
			end: '20:00',
			early: '19:00',
			late: '12:00'
		};
	}
}

export default Info
